export default __webpack_public_path__ + "static/media/head-left-side.0e520504.png";